module.exports = __webpack_public_path__ + "media/images/signatures/zsofi_signature_white-e6aeda15c649d3aedf66f08806107cf5.png";